export { View as LoanBonus } from './view'
